<template>
  <div>
    <section class="hero d-flex align-center">
      <div class="hero__content">
        <h3>
          <moving-words>
            نحن نقوم بإنشاء محتوى رقمي يتفاعل ويرتبط بالناس
          </moving-words>
        </h3>
      </div>
    </section>
    <section class="work">
      <slider :items="projects"></slider>
    </section>
    <section class="grid">
      <h2 class="big-title big-title--pl">نقدم</h2>
      <services></services>
    </section>
    <contact :has-padding="false"/>
  </div>
</template>

<script>
import MovingWords from '@/components/MovingWords'
import Slider from '@/components/Slider'
import Services from '@/components/Services'
import Contact from '@/components/Contact'
import Projects from '@/data/projects'

export default {
  name: 'Home',
  components: {
    MovingWords,
    Slider,
    Services,
    Contact
  },
  data () {
    return {
      projects: Projects,
      offsets: [],
      inMove: false,
      activeSection: 0,
      touchStartY: 0
    }
  },
  computed: {
    isMobile () {
      return window.innerWidth <= 960
    }
  },
  methods: {
    calculateSectionOffsets () {
      const sections = document.getElementsByTagName('section')
      const length = sections.length

      for (let i = 0; i < length; i++) {
        const sectionOffset = sections[i].offsetTop
        this.offsets.push(sectionOffset)
      }
    },

    scrollToSection (id, force = false) {
      if (this.inMove && !force) return false
      this.activeSection = id
      this.inMove = true
      document.getElementsByTagName('section')[id].scrollIntoView({
        behavior: 'smooth'
      })
      setTimeout(() => {
        this.inMove = false
      }, 400)
    },

    handleMouseWheel: function (e) {
      if (e.wheelDelta < 30 && !this.inMove) {
        this.moveUp()
      } else if (e.wheelDelta > 30 && !this.inMove) {
        this.moveDown()
      }
      e.preventDefault()
      return false
    },

    moveDown () {
      this.inMove = true
      this.activeSection--

      if (this.activeSection < 0) this.activeSection = this.offsets.length - 1

      this.scrollToSection(this.activeSection, true)
    },

    moveUp () {
      this.inMove = true
      this.activeSection++

      if (this.activeSection > this.offsets.length - 1) this.activeSection = 0

      this.scrollToSection(this.activeSection, true)
    },

    touchStart (e) {
      e.preventDefault()

      this.touchStartY = e.touches[0].clientY
    },

    touchMove (e) {
      if (this.inMove) return false
      e.preventDefault()

      const currentY = e.touches[0].clientY

      if (this.touchStartY < currentY) {
        this.moveDown()
      } else {
        this.moveUp()
      }

      this.touchStartY = 0
      return false
    }
  },

  mounted () {
    if (!this.isMobile) { this.calculateSectionOffsets() }
  },

  created () {
    if (!this.isMobile) {
      window.addEventListener('DOMMouseScroll', this.handleMouseWheelDOM) // Mozilla Firefox
      window.addEventListener('mousewheel', this.handleMouseWheel, {
        passive: false
      }) // Other browsers
      window.addEventListener('touchstart', this.touchStart, {
        passive: false
      }) // mobile devices
      window.addEventListener('touchmove', this.touchMove, {
        passive: false
      }) // mobile devices
    }
  },

  destroyed () {
    if (!this.isMobile) {
      window.removeEventListener('mousewheel', this.handleMouseWheel, {
        passive: false
      }) // Other browsers
      window.removeEventListener('DOMMouseScroll', this.handleMouseWheelDOM) // Mozilla Firefox
      window.removeEventListener('touchstart', this.touchStart) // mobile devices
      window.removeEventListener('touchmove', this.touchMove) // mobile devices
    }
  }
}
</script>

<style lang="scss">
.hero {
  height: 100vh;
  padding: 2rem;
  margin-bottom: 0 !important;

  .hero__content {
    @media screen and (min-width: 960px) {
      max-width: 63%;
    }
  }

  h3 {
    @media screen and (min-width: 960px) {
      padding-right: 5rem;
    }
  }
}

.grid {
  @media screen and (min-width: 960px) {
    display: grid;
    grid-template-columns: 40% 60%;
    align-content: center;
  }
}

// selector here might be section:not(.hero)
// .work {
  // padding-top: 3rem;

  // h1 {
  //   padding-right: 12rem;
  // }
// }
</style>
